import { GuideScheduleReason } from "../scheduler/scheduler";
import { TourTerminateReason } from "./tourLifecycleManager";

export type TourSessionManagerEvents = {
  tourSessionExpired: { sessionId: string };
  tourSessionStarted: { sessionId: string; startedAt: number; reason: GuideScheduleReason };
  tourSessionResumed: { sessionId: string };
  tourSessionTerminated: { sessionId: string; reason: TourTerminateReason };
};

export const TourSessionManagerNamespace = "tourSessionManager" as const;
